
import jQuery  from 'jquery';
window.jQuery  = jQuery;
$  =  jQuery;


var timezoneMapping = {
    "Andorra":"Europe/Andorra",
    "United Arab Emirates":"Asia/Dubai",
    "Afghanistan":"Asia/Kabul",
    "Antigua and Barbuda":"America/Antigua",
    "Anguilla":"America/Anguilla",
    "Albania":"Europe/Tirane",
    "Armenia":"Asia/Yerevan",
    "Angola":"Africa/Luanda",
    "Argentina":"America/Argentina",
    "American Samoa":"Pacific/Pago_Pago",
    "Austria":"Europe/Vienna",
    "Australia":"Australia/Sydney",
    "Aruba":"America/Aruba",
    "Åland Island":"Europe/Mariehamn",
    "Azerbaijan":"Asia/Baku",
    "Bosnia and Herzegovina":"Europe/Sarajevo",
    "Barbados":"America/Barbados",
    "Bangladesh":"Asia/Dhaka",
    "Belgium":"Europe/Brussels",
    "Burkina Faso":"Africa/Ouagadougou",
    "Bulgaria":"Europe/Sofia",
    "Bahrain":"Asia/Bahrain",
    "Burundi":"Africa/Bujumbura",
    "Benin":"Africa/Porto-Novo",
    "Saint Barthélemy":"America/St_Barthelemy",
    "Bermuda":"Atlantic/Bermuda",
    "Brunei":"Asia/Brunei",
    "Bolivia":"America/La_Paz",
    "British Antarctic Territory":"America/Kralendijk",
    "Brazil":"America/Sao_Paulo",
    "Bahamas":"America/Nassau",
    "Bhutan":"Asia/Thimphu",
    "Botswana":"Africa/Gaborone",
    "Belarus":"Europe/Minsk",
    "Belize":"America/Belize",
    "Canada":"America/Toronto",
    "Cocos [Keeling] Islands":"Indian/Cocos",
    "Congo - Kinshasa":"Africa/Kinshasa",
    "Central African Republic":"Africa/Bangui",
    "Congo - Brazzaville":"Africa/Brazzaville",
    "Switzerland":"Europe/Zurich",
    "Côte d’Ivoire":"Africa/Abidjan",
    "Cook Islands":"Pacific/Rarotonga",
    "Chile":"America/Santiago",
    "Cameroon":"Africa/Douala",
    "China":"Asia/Shanghai",
    "Colombia":"America/Bogota",
    "Costa Rica":"America/Costa_Rica",
    "Cuba":"America/Havana",
    "Cape Verde":"Atlantic/Cape_Verde",
    "Christmas Island":"Indian/Christmas",
    "Cyprus":"Asia/Nicosia",
    "Czech Republic":"Europe/Prague",
    "Germany":"Europe/Berlin",
    "Djibouti":"Africa/Djibouti",
    "Denmark":"Europe/Copenhagen",
    "Dominica":"America/Dominica",
    "Dominican Republic":"America/Santo_Domingo",
    "Algeria":"Africa/Algiers",
    "Ecuador":"America/Guayaquil",
    "Estonia":"Europe/Tallinn",
    "Egypt":"Africa/Cairo",
    "Western Sahara":"Africa/El_Aaiun",
    "Eritrea":"Africa/Asmara",
    "Spain":"Europe/Madrid",
    "Ethiopia":"Africa/Addis_Ababa",
    "Finland":"Europe/Helsinki",
    "Fiji":"Pacific/Fiji",
    "Falkland Islands":"Atlantic/Stanley",
    "Micronesia":"Pacific/Chuuk",
    "Faroe Islands":"Atlantic/Faroe",
    "France":"Europe/Paris",
    "Gabon":"Africa/Libreville",
    "United Kingdom":"Europe/London",
    "Grenada":"America/Grenada",
    "Georgia":"Asia/Tbilisi",
    "French Guiana":"America/Cayenne",
    "Guernsey":"Europe/Guernsey",
    "Ghana":"Africa/Accra",
    "Gibraltar":"Europe/Gibraltar",
    "Greenland":"America/Thule",
    "Gambia":"Africa/Banjul",
    "Guinea":"Africa/Conakry",
    "Guadeloupe":"America/Guadeloupe",
    "Equatorial Guinea":"Africa/Malabo",
    "Greece":"Europe/Athens",
    "South Georgia and the South Sandwich Islands":"Atlantic/South_Georgia",
    "Guatemala":"America/Guatemala",
    "Guam":"Pacific/Guam",
    "Guinea-Bissau":"Africa/Bissau",
    "Guyana":"America/Guyana",
    "Hong Kong SAR China":"Asia/Hong_Kong",
    "Honduras":"America/Tegucigalpa",
    "Croatia":"Europe/Zagreb",
    "Haiti":"America/Port-au-Prince",
    "Hungary":"Europe/Budapest",
    "Indonesia":"Asia/Jakarta",
    "Ireland":"Europe/Dublin",
    "Israel":"Asia/Jerusalem",
    "Isle of Man":"Europe/Isle_of_Man",
    "India":"Asia/Kolkata",
    "British Indian Ocean Territory":"Indian/Chagos",
    "Iraq":"Asia/Baghdad",
    "Iran":"Asia/Tehran",
    "Iceland":"Atlantic/Reykjavik",
    "Italy":"Europe/Rome",
    "Jersey":"Europe/Jersey",
    "Jamaica":"America/Jamaica",
    "Jordan":"Asia/Amman",
    "Japan":"Asia/Tokyo",
    "Kenya":"Africa/Nairobi",
    "Kyrgyzstan":"Asia/Bishkek",
    "Cambodia":"Asia/Phnom_Penh",
    "Kiribati":"Pacific/Kiritimati",
    "Comoros":"Indian/Comoro",
    "Saint Kitts and Nevis":"America/St_Kitts",
    "North Korea":"Asia/Pyongyang",
    "South Korea":"Asia/Seoul",
    "Kuwait":"Asia/Kuwait",
    "Cayman Islands":"America/Cayman",
    "Kazakhstan":"Asia/Almaty",
    "Laos":"Asia/Vientiane",
    "Lebanon":"Asia/Beirut",
    "Saint Lucia":"America/St_Lucia",
    "Liechtenstein":"Europe/Vaduz",
    "Sri Lanka":"Asia/Colombo",
    "Liberia":"Africa/Monrovia",
    "Lesotho":"Africa/Maseru",
    "Lithuania":"Europe/Vilnius",
    "Luxembourg":"Europe/Luxembourg",
    "Latvia":"Europe/Riga",
    "Libya":"Africa/Tripoli",
    "Morocco":"Africa/Casablanca",
    "Monaco":"Europe/Monaco",
    "Moldova":"Europe/Chisinau",
    "Montenegro":"Europe/Podgorica",
    "Saint Martin":"America/Marigot",
    "Madagascar":"Indian/Antananarivo",
    "Marshall Islands":"Pacific/Majuro",
    "Macedonia":"Europe/Skopje",
    "Mali":"Africa/Bamako",
    "Myanmar [Burma]":"Asia/Rangoon",
    "Mongolia":"Asia/Ulaanbaatar",
    "Macau SAR China":"Asia/Macau",
    "Northern Mariana Islands":"Pacific/Saipan",
    "Martinique":"America/Martinique",
    "Mauritania":"Africa/Nouakchott",
    "Montserrat":"America/Montserrat",
    "Malta":"Europe/Malta",
    "Mauritius":"Indian/Mauritius",
    "Maldives":"Indian/Maldives",
    "Malawi":"Africa/Blantyre",
    "Mexico":"America/Mexico_City",
    "Malaysia":"Asia/Kuala_Lumpur",
    "Mozambique":"Africa/Maputo",
    "Namibia":"Africa/Windhoek",
    "New Caledonia":"Pacific/Noumea",
    "Niger":"Africa/Niamey",
    "Norfolk Island":"Pacific/Norfolk",
    "Nigeria":"Africa/Lagos",
    "Nicaragua":"America/Managua",
    "Netherlands":"Europe/Amsterdam",
    "Norway":"Europe/Oslo",
    "Nepal":"Asia/Kathmandu",
    "Nauru":"Pacific/Nauru",
    "Niue":"Pacific/Niue",
    "New Zealand":"Pacific/Auckland",
    "Oman":"Asia/Muscat",
    "Panama":"America/Panama",
    "Peru":"America/Lima",
    "French Polynesia":"Pacific/Tahiti",
    "Papua New Guinea":"Pacific/Port_Moresby",
    "Philippines":"Asia/Manila",
    "Pakistan":"Asia/Karachi",
    "Poland":"Europe/Warsaw",
    "Saint Pierre and Miquelon":"America/Miquelon",
    "Pitcairn Islands":"Pacific/Pitcairn",
    "Puerto Rico":"America/Puerto_Rico",
    "Palestinian Territories":"Asia/Gaza",
    "Portugal":"Atlantic/Madeira",
    "Palau":"Pacific/Palau",
    "Paraguay":"America/Asuncion",
    "Qatar":"Asia/Qatar",
    "Réunion":"Indian/Reunion",
    "Romania":"Europe/Bucharest",
    "Serbia":"Europe/Belgrade",
    "Russia":"Europe/Moscow",
    "Rwanda":"Africa/Kigali",
    "Saudi Arabia":"Asia/Riyadh",
    "Solomon Islands":"Pacific/Guadalcanal",
    "Seychelles":"Indian/Mahe",
    "Sudan":"Africa/Khartoum",
    "Sweden":"Europe/Stockholm",
    "Singapore":"Asia/Singapore",
    "Saint Helena":"Atlantic/St_Helena",
    "Slovenia":"Europe/Ljubljana",
    "Svalbard and Jan Mayen":"Arctic/Longyearbyen",
    "Slovakia":"Europe/Bratislava",
    "Sierra Leone":"Africa/Freetown",
    "San Marino":"Europe/San_Marino",
    "Senegal":"Africa/Dakar",
    "Somalia":"Africa/Mogadishu",
    "Suriname":"America/Paramaribo",
    "São Tomé and Príncipe":"Africa/Sao_Tome",
    "El Salvador":"America/El_Salvador",
    "Syria":"Asia/Damascus",
    "Swaziland":"Africa/Mbabane",
    "Turks and Caicos Islands":"America/Grand_Turk",
    "Chad":"Africa/Ndjamena",
    "French Southern Territories":"Indian/Kerguelen",
    "Togo":"Africa/Lome",
    "Thailand":"Asia/Bangkok",
    "Tajikistan":"Asia/Dushanbe",
    "Tokelau":"Pacific/Fakaofo",
    "Timor-Leste":"Asia/Dili",
    "Turkmenistan":"Asia/Ashgabat",
    "Tunisia":"Africa/Tunis",
    "Tonga":"Pacific/Tongatapu",
    "Turkey":"Europe/Istanbul",
    "Trinidad and Tobago":"America/Port_of_Spain",
    "Tuvalu":"Pacific/Funafuti",
    "Taiwan":"Asia/Taipei",
    "Tanzania":"Africa/Dar_es_Salaam",
    "Ukraine":"Europe/Kiev",
    "Uganda":"Africa/Kampala",
    "U.S. Minor Outlying Islands":"Pacific/Midway",
    "United States":"America/New_York",
    "Uruguay":"America/Montevideo",
    "Uzbekistan":"Asia/Tashkent",
    "Vatican City":"Europe/Vatican",
    "Saint Vincent and the Grenadines":"America/St_Vincent",
    "Venezuela":"America/Caracas",
    "British Virgin Islands":"America/Tortola",
    "U.S. Virgin Islands":"America/St_Thomas",
    "Vietnam":"Asia/Ho_Chi_Minh",
    "Vanuatu":"Pacific/Efate",
    "Wallis and Futuna":"Pacific/Wallis",
    "Samoa":"Pacific/Apia",
    "Yemen":"Asia/Aden",
    "Mayotte":"Indian/Mayotte",
    "South Africa":"Africa/Johannesburg",
    "Zambia":"Africa/Lusaka",
    "Zimbabwe":"Africa/Harare"
};

$(function () {

    // update the timezone based on the choice made handler
    if ($('#ProfileCompleteForm_ProfileCompleteForm').length) {

        // Set up the picker to update target timezone and country select lists.
        $('#Country').chosen().change(function(event, params) {
            var timezone = $('#TimeZone');
            timezone.val(timezoneMapping[params.selected]);
            timezone.trigger("chosen:updated");
        });

    }
});



// WEBPACK FOOTER //
// ./js/modules/timezone.picker.js